import {
  BaSeButton,
  BaSeCheckbox,
  BaSeContainer,
  BaSeDialogContext,
  BaSeFilePicker,
  BaSeGrid,
  BaSeGridItem,
  BaSeInput,
  BaSeParagraph,
  BaSeSmall2,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import EadTitlePage from '../layout/ead-title-page';
import { SectionButton } from '../shared/grid/grid-wrapper-styled';
import { useBreakpoint } from '../../hooks/breakpoints';
import { WrapperLink } from './abertura-chamado-styled';

// eslint-disable-next-line sonarjs/cognitive-complexity
const FormChamado = ({ sessionToken, glpiUrl }) => {
  const [cpf, setCpf] = React.useState();
  const [nome, setNome] = React.useState();
  const [email, setEmail] = React.useState();
  const [checkAgree, setCheckeAgree] = React.useState(false);
  const [mensagem, setMensagem] = React.useState();
  const [recaptchaKey, setRecaptchaKey] = React.useState(null);
  const [recaptchaValid, setRecaptchaValid] = React.useState(false);
  const [byPassSend, setByPassSend] = React.useState(false);
  const [reason, setReason] = React.useState(null);
  const [subject, setSubject] = React.useState(null);
  const [arquivos, setArquivos] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const { showNotification } = React.useContext(BaSeDialogContext);
  const { navigateTo } = Sebrae.useRouter();
  const { keycloak } = Sebrae.useAuth();
  const { getEnv } = Sebrae.useEnv();
  const { httpGet, httpPost } = Sebrae.useHttp(sessionToken);
  const { isMobile } = useBreakpoint();
  const { azulSebrae36, cinzaSebrae45 } = BaSeTheme.colors.institucionais;
  const captchaRef = React.useRef(null);

  React.useEffect(() => {
    const { tokenParsed } = keycloak;
    setNome(tokenParsed?.name ?? '');
    setCpf(tokenParsed?.cpf ?? '');
    setEmail(tokenParsed?.email ?? '');
  }, [keycloak]);

  const categories = React.useCallback(
    (data, setFunc) => {
      const params = {
        'criteria[0][field]': data.field,
        'criteria[0][value]': data.value,
        'criteria[0][searchtype]': data.searchtype,
      };

      httpGet(`${glpiUrl}/apirest.php/search/ITILCategory`, params)
        .then((res) => {
          let listCatefories = [];
          const dados = res.data;
          dados.forEach((assunto) => {
            listCatefories.push({ id: assunto?.[2], label: assunto?.[14] });
          });
          setFunc(listCatefories?.[0]);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [glpiUrl, httpGet],
  );

  React.useEffect(() => {
    const criteria = {
      field: 2,
      searchtype: 'equals',
    };

    if (!!sessionToken && !!Object.keys(sessionToken).length) {
      categories({ ...criteria, value: 2917 }, setReason);
      categories({ ...criteria, value: 2912 }, setSubject);
    }
  }, [categories, sessionToken]);

  const PrivaciPolicy = () => (
    <WrapperLink>
      {`Estou de acordo com a `}
      <a
        href="https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BaSeParagraph color={azulSebrae36}>
          política de privacidade
        </BaSeParagraph>
      </a>
    </WrapperLink>
  );

  const removeRequerente = React.useCallback(
    async (idTicket) => {
      httpGet(`${glpiUrl}/apirest.php/Ticket/${idTicket}/Ticket_User`)
        .then()
        .catch((error) => {
          console.log(error);
        });
    },
    [glpiUrl, httpGet],
  );

  const getUser = React.useCallback(
    async (email) => {
      return await httpGet(
        `${glpiUrl}/apirest.php/User?searchText[name]=${email}`,
      )
        .then()
        .catch((error) => {
          console.log(error);
        });
    },
    [glpiUrl, httpGet],
  );

  const addRequester = React.useCallback(
    async (idTicket, email) => {
      let user = [];
      try {
        user = await getUser(email);
      } catch (error) {
        console.log(error);
      }
      let newRequester = {
        input: {
          tickets_id: idTicket,
          users_id: 0,
          type: 1,
          use_notification: 1,
          alternative_email: email,
        },
      };

      if (user?.length > 0) {
        newRequester = {
          input: {
            tickets_id: idTicket,
            users_id: user[0].id,
            type: 1,
            use_notification: 1,
          },
        };
      }

      await httpPost(`${glpiUrl}/apirest.php/Ticket_User`, newRequester)
        .then((resp) => {
          return resp;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [getUser, glpiUrl, httpPost],
  );

  const associarFiles = React.useCallback(
    async (id, arquivos) => {
      let inputBody = [];
      arquivos.map((fil) => {
        let obj = {
          documents_id: fil.id,
          items_id: id,
          itemtype: 'Ticket',
        };
        inputBody.push(obj);
        return fil;
      });
      let body = {
        input: inputBody,
      };

      return await httpPost(
        `${glpiUrl}/apirest.php/Ticket/${id}/Document_Item`,
        body,
      )
        .then()
        .catch((error) => {
          console.log(error);
        });
    },
    [glpiUrl, httpPost],
  );

  const criarTicket = React.useCallback(
    async (descricao, titulo, email, idEntidade, idCategoria) => {
      const newTicket = {
        input: {
          entities_id: idEntidade,
          name: titulo,
          content: descricao,
          requesttypes_id: 8,
          itilcategories_id: idCategoria,
        },
      };

      try {
        await httpPost(`${glpiUrl}/apirest.php/Ticket`, newTicket)
          .then(async (resp) => {
            await removeRequerente(resp?.id);
            await addRequester(resp.id, email);
            if (arquivos.length > 0) {
              await associarFiles(resp?.id, arquivos)
                .then((data) => {
                  setLoading(false);
                })
                .catch((error) => {
                  console.error(error);
                  setLoading(false);
                })
                .finally(() => setLoading(false));
            } else {
              setLoading(false);
            }
            return resp?.id;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    },
    [
      addRequester,
      arquivos,
      associarFiles,
      glpiUrl,
      httpPost,
      removeRequerente,
    ],
  );

  const sendFiles = React.useCallback(
    async (idEntidade) => {
      await arquivos.map(async (file) => {
        setLoading(true);
        let formData = new FormData();
        formData.append(
          'uploadManifest',
          '{"input": {"name": "Uploaded document","_filename":"' +
            file.name +
            '","entities_id":' +
            idEntidade +
            '}}',
        );
        formData.append('filename[0]', file, 'slogo-azul.png');

        await httpPost(`${glpiUrl}/apirest.php/Document`, formData)
          .then((data) => {
            file.id = data.id;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => setLoading(false));
      });
    },
    [arquivos, glpiUrl, httpPost],
  );

  const enviar = React.useCallback(() => {
    const conteudo =
      'Nome: ' +
      nome +
      ' \n' +
      'CPF: ' +
      cpf +
      '\n' +
      'Motivo: ' +
      (subject ? subject.label : reason?.label) +
      '\n' +
      'E-mail: ' +
      email +
      '\n' +
      // (canal ? 'Canal de entrada: ' + canal + '\n' : '') +
      'Mensagem: ' +
      mensagem +
      '\n';
    const idEntidade = 167;

    if (arquivos.length > 0) {
      sendFiles(idEntidade);
    }
    setLoading(true);
    criarTicket(
      conteudo,
      cpf + ' - ' + subject?.label,
      email,
      idEntidade,
      subject?.id,
    )
      .then((resp) => {
        showNotification({
          message: `Chamado enviado com sucesso!`,
          color: 'confirmation',
          secondsToClose: 50,
        });
        navigateTo('/certificados');
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  }, [
    arquivos,
    cpf,
    criarTicket,
    email,
    mensagem,
    navigateTo,
    nome,
    reason,
    sendFiles,
    showNotification,
    subject,
  ]);

  React.useEffect(() => {
    async function envRecaptcha() {
      return await getEnv('REACT_APP_RECAPTCHA_SITE_KEY').then(setRecaptchaKey);
    }
    envRecaptcha();
  }, [getEnv]);

  const onChangeCaptcha = React.useCallback(() => {
    if (captchaRef && captchaRef.current.getValue()) {
      setRecaptchaValid(true);
    }
  }, []);

  React.useEffect(() => {
    const activeButton =
      !!cpf &&
      !!nome &&
      !!email &&
      !!mensagem &&
      checkAgree &&
      !!recaptchaValid;

    setByPassSend(activeButton);
  }, [checkAgree, cpf, email, mensagem, nome, recaptchaValid]);

  return (
    <div style={{ margin: '0 20px' }}>
      <EadTitlePage title="Abertura de chamado" />
      <BaSeContainer delimitedOnBreakpoint="desktop">
        <BaSeParagraph color={cinzaSebrae45}>
          Preencha os campos para enviar o formulário:
        </BaSeParagraph>
        <div>
          <BaSeGrid>
            <BaSeGridItem>
              <BaSeGrid>
                <BaSeGridItem size={isMobile() ? 12 : 4}>
                  <BaSeInput
                    isDisabled
                    label="CPF"
                    mask="cpf"
                    onChange={(e) => setCpf(e)}
                    value={cpf}
                  />
                </BaSeGridItem>
              </BaSeGrid>
            </BaSeGridItem>
            <BaSeGridItem size={isMobile() ? 12 : 6}>
              <BaSeInput
                isDisabled
                label="Nome completo"
                onChange={(e) => setNome(e)}
                value={nome}
              />
            </BaSeGridItem>
            <BaSeGridItem size={isMobile() ? 12 : 6}>
              <BaSeInput
                isDisabled
                label="E-mail"
                typeInput="email"
                onChange={(e) => setEmail(e)}
                value={email}
              />
            </BaSeGridItem>
            <BaSeGridItem size={12}>
              <BaSeTextArea
                value={mensagem}
                onChange={setMensagem}
                label="Mensagem"
                placeholder="Descreva em detalhes como podemos te ajudar"
                hasCounter="chars"
                rows={3}
              />
            </BaSeGridItem>
            <BaSeGridItem size={12}>
              <BaSeFilePicker
                label="Envie arquivos ou qualquer outro item que possa ser importante:"
                subLabel="(Opcional)"
                acceptsFilesPattern="*"
                onChange={(files) => {
                  setArquivos(files);
                }}
                validateFiles={(files) => {
                  const typeFiles = [
                    'image/jpeg',
                    'image/png',
                    'application/pdf',
                    'application/zip',
                    'image/tiff',
                  ];
                  const maxSize = 2000000;
                  const listValidFiles = files.filter(
                    (ele) =>
                      typeFiles.includes(ele.type) && ele.size <= maxSize,
                  );

                  const listInvalidFiles = files.filter(
                    (ele) =>
                      !typeFiles.includes(ele.type) || ele.size > maxSize,
                  );

                  const errors = listInvalidFiles.map((e, index) => (
                    <span style={{ display: 'grid' }} key={index}>
                      {`-${e.name}`}
                    </span>
                  ));

                  if (!!listInvalidFiles.length) {
                    showNotification({
                      message: 'Arquivo não permitido!',
                      supportMessage: errors,
                      color: 'destructive',
                      secondsToClose: 15,
                    });
                  }

                  return listValidFiles;
                }}
                onError={({ error }) => console.log('erro', error)}
                pickMultipleFiles
                renderStyle="box"
                dragInfoText={
                  <>
                    <BaSeParagraph color={cinzaSebrae45}>
                      Use o botão ou arraste o arquivo aqui para adicioná-lo ou
                      arraste aqui para adicionar.
                    </BaSeParagraph>
                    <BaSeParagraph color={cinzaSebrae45}>
                      Formatos permitidos: JPG, PNG, PDF, ZIP e TIFF. Tamanho
                      máximo de 2MB.
                    </BaSeParagraph>
                  </>
                }
              />

              <BaSeGridItem size={6}>
                <div style={{ margin: '32px 0 22px' }}>
                  <BaSeSmall2 color={cinzaSebrae45}>
                    Por razões de segurança, por favor responda à questão abaixo
                    para enviar o formulário:
                  </BaSeSmall2>
                  {!!recaptchaKey && (
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey={recaptchaKey ?? ''}
                      onChange={onChangeCaptcha}
                      onExpired={() => setRecaptchaValid(false)}
                      onErrored={() => setRecaptchaValid(false)}
                    />
                  )}
                </div>
              </BaSeGridItem>
            </BaSeGridItem>
          </BaSeGrid>

          <BaSeCheckbox
            label={<PrivaciPolicy />}
            checked={checkAgree}
            onChange={() => setCheckeAgree(!checkAgree)}
            size="small"
          />

          <SectionButton>
            <BaSeButton
              isDisabled={!byPassSend}
              buttonType="button"
              color="default"
              isLoading={loading}
              onClick={enviar}
              size="medium"
              type="primary"
              value="Enviar formulário"
            />
            <BaSeButton
              isDisabled={loading}
              buttonType="button"
              color={azulSebrae36}
              onClick={() => navigateTo('/certificados')}
              size="medium"
              type="secondary"
              value="Cancelar"
            />
          </SectionButton>
        </div>
      </BaSeContainer>
    </div>
  );
};

export { FormChamado as default };
